import {LitElement, html, css} from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { router } from "lit-element-router";
import "./main-view.js";
import "./login-view.js";
import "./post-view.js";
import "./not-found.js";
import "./settings-view.js";
import "./sidebar.component.js";
import "./../components/slds-search.js";
import "./../components/slds-dropdown.js";
import "./../components/slds-spinner.js";
import "./../components/slds-dialog.js";
import "./profile-view.js";
import { SldsBaseElement } from '../components/slds-base-element.js';
import { connect } from 'pwa-helpers/connect-mixin.js';
import store, { resetStateField } from '../src/store';
import { setTheme, setRoute, setFollowingDialog, setUser, addNotification } from '../src/store';
import { updateSettings, uploadProfilePicture, search } from '../src/apiActions';
import authManager from '../src/authManager';
import { unsafeHTML } from 'lit-html/directives/unsafe-html.js';

@customElement('app-view')
class AppView extends connect(store)(router(SldsBaseElement)) {
  @property({type: Boolean}) mobileMode = false;
  @property({type: Boolean}) toggleMenu = true;
  @property({type: Number}) count = 0;
  @property({type: String}) route = '';
  @property({type: Object}) params = {};
  @property({type: Object}) query = {};
  @property({type: String}) selected = '';
  @property({type: String}) postOpen = '';
  @property({type: Array}) profileDropdownLoggedIn = [
    {label:'User Actions', type: 'header'},
    {label:'My Profile', href: 'profile'},
    {label:'Customize', href: 'customize-tags'},
    {label:'Saved', href: 'profile/saved'},
    {label:'Settings', href: 'settings'},
    {label:'Dark Mode', value: 'dark-mode', type: 'toggle'},
    {label:'Help Center', href: 'help-center'},
    {label:'Report Problems', href: 'report-problems'},
    {label:'Log Out', value: 'log-out'},
    {type: 'hr'},
    {label:'Additional Actions', type: 'header'},
    {label:'Terms & Policies', href: 'tos-policies'},
    {label:'Advertise', href: 'advertise'},
    {label:'Contact', href: 'contact'},
    {label:'Roflcopter @ 2024-2025', type: 'footer'},
  ];
  @property({type: Array}) profileDropdownNotLoggedIn = [
    {label:'User Actions', type: 'header'},
    {label:'Dark Mode', value: 'dark-mode', type: 'toggle'},
    {label:'Help Center', href: 'help-center'},
    {label:'Report Problems', href: 'report-problems'},
    {label:'Login', href: 'login'},
    {type: 'hr'},
    {label:'Additional Actions', type: 'header'},
    {label:'Terms & Policies', href: 'tos-policies'},
    {label:'Advertise', href: 'advertise'},
    {label:'Contact', href: 'contact'},
    {label:'Roflcopter @ 2024-2025', type: 'footer'},
  ];
  @property({type: Array}) profileDropdown = [];
  @property({ type: Array })
  categories = [
    { id: 'girl-nsfw', title: 'Girl NSFW', icon: '/assets/categories/girl&nsfw.svg', adultContent: true },
    { id: 'guy-nsfw', title: 'Guy NSFW', icon: '/assets/categories/guy&nsfw.svg', adultContent: true },
    { id: 'crypto', title: 'Crypto', icon: '/assets/categories/crypto.svg' },
    { id: 'anime-nsfw', title: 'Anime NSFW', icon: '/assets/categories/anime-nsfw.svg', adultContent: true },
    { id: 'anime-manga', title: 'Anime & Manga', icon: '/assets/categories/anime&manga.svg' },
    { id: 'latest-news', title: 'Latest News', icon: '/assets/categories/latest-news.svg' },
    { id: 'girl', title: 'Girl', icon: '/assets/categories/girl.svg' },
    { id: 'humor', title: 'Humor', icon: '/assets/categories/humor.svg' },
    { id: 'memes', title: 'Memes', icon: '/assets/categories/memes.svg' },
    { id: 'gaming', title: 'Gaming', icon: '/assets/categories/gaming.svg' },
    { id: 'wtf', title: 'WTF', icon: '/assets/categories/wtf.svg' },
    { id: 'relationship-dating', title: 'Relationship & Dating', icon: '/assets/categories/relationship&dating.svg' },
    { id: 'motor-vehicles', title: 'Motor Vehicles', icon: '/assets/categories/motor&vehicles.svg' },
    { id: 'animals-pets', title: 'Animals & Pets', icon: '/assets/categories/animals&pets.svg' },
    { id: 'science-tech', title: 'Science & Tech', icon: '/assets/categories/science&tech.svg' },
    { id: 'comic', title: 'Comic', icon: '/assets/categories/comic.svg' },
    { id: 'wholesome', title: 'Wholesome', icon: '/assets/categories/wholesome.svg' },
    { id: 'sports', title: 'Sports', icon: '/assets/categories/sports.svg' },
    { id: 'movies-tv', title: 'Movies & TV', icon: '/assets/categories/movies&tv.svg' },
    { id: 'cat', title: 'Cat', icon: '/assets/categories/cat.svg' },
    { id: 'food-drinks', title: 'Food & Drinks', icon: '/assets/categories/food&drinks.svg' },
    { id: 'lifestyle', title: 'Lifestyle', icon: '/assets/categories/lifestyle.svg' },
    { id: 'superhero', title: 'Superhero', icon: '/assets/categories/superhero.svg' },
    { id: 'random', title: 'Random', icon: '/assets/categories/random.svg' },
    { id: 'woah', title: 'Woah', icon: '/assets/categories/woah.svg' },
    { id: 'russo-ukrainian-war', title: 'Russo Ukrainian War', icon: '/assets/categories/russo-ukrainian-war.svg' },
    { id: 'profile-only', title: 'Profile Only', icon: '/assets/categories/profile.svg', onlyPost: true }
  ];
  @property({type: Boolean}) profileDropdownOpen = false;
  @property({ type: Boolean }) isLoading = true;
  @property({ type: String }) theme = 'light';
  @property({ type: String }) accessToken = '';
  @property({ type: Object }) user = null;
  @property({ type: String }) mainType = '';
  @property({ type: String }) mainId = '';
  @property({ type: Boolean }) followingDialog = false;
  @property({ type: Boolean }) mustBeLoggedIn = false;
  @property({ type: Boolean }) mustBeLoggedInDialog = true;
  @property({ type: Boolean }) mustBeLoggedInDialogOptional = true;
  @property({ type: Boolean }) newUserCreated = false;
  @property({ type: Boolean }) openANewUser = false;
  @property({type: Boolean}) notifyOpen = false;
  @property({type: Boolean}) updatingUser = false;
  @property({ type: String }) selectedProfileTab = 'posts';
  @property({ type: Array }) searchResults = null;
  @property({ type: Array }) notifications = [];
  @property({ type: Number }) settingsUpdated = null;
  @property({type: Object}) adultMode = false;
  @property({ type: Object }) askToLogin = null;
  @property({ type: Boolean }) isDragging = false;
  @property({ type: Number }) previousX = 0;
  @property({ type: Number }) lastScrollTop = 0;
  @property({ type: Boolean }) headerHidden = false;

  constructor() {
    super();
    if ( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
      this.mobileMode = true;
      this.toggleMenu = false;
    }
    console.log("Mobile mode", this.mobileMode);
    document.body.appendChild(this.loadGlobalStyles(document.body));
    requestAnimationFrame(() => {
      if (this.mobileMode) {
        this.shadowRoot.getElementById('sidebar').style.setProperty('--drawer-delta', '18rem');
      }
    });
  }

  connectedCallback() {
    super.connectedCallback();
    var theme = localStorage.getItem("theme");
    window.override = true;
    if (!theme) {
      theme = "light";
      window.override = false;
    }
    if (!window.override)
    {
      if(window.matchMedia && window.matchMedia("(prefers-color-scheme:dark)").matches) {
        theme = "dark";
      } else {
        theme = "light";
      }
    }
    if (theme === "dark") {
      document.documentElement.classList.add('dark');
    }
    store.dispatch(setTheme(theme));
    window.addEventListener('load', this._onLoad.bind(this));
    window.addEventListener('scroll', this._onScroll.bind(this));
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener('load', this._onLoad.bind(this));
    window.removeEventListener('scroll', this._onScroll.bind(this));
  }

  _onLoad() {
    this.isLoading = false;
  }

  _onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > this.lastScrollTop && scrollTop > 100) {
      this.headerHidden = true;
    } else {
      this.headerHidden = false;
    }
    this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  }

  stateChanged(state) {
    this.theme = state.theme;
    this.accessToken = state.accessToken;
    this.user = state.user;
    if (this.user) {
      this.adultMode = (this.user.adultContent === true);
      this.profileDropdown = this.profileDropdownLoggedIn;
    }
    else {
      this.profileDropdown = this.profileDropdownNotLoggedIn;
    }
    if (state.askToLogin) {
      this.openANewUser = true;
      this.askToLogin = state.askToLogin;
      store.dispatch(resetStateField('askToLogin'));
    }
    if (state.followingDialog) {
      this.followingDialog = state.followingDialog;
      store.dispatch(resetStateField('followingDialog'))
    }
    if (state.settingsUpdated !== this.settingsUpdated) {
      this.updatingUser = false;
      this.newUserCreated = false;
      this.settingsUpdated = state.settingsUpdated;
    }
    if (state.newUserCreated) {
      this.newUserCreated = state.newUserCreated;
      store.dispatch(resetStateField('newUserCreated'));
    }
    if (state.searchResults) {
      this.searchResults = state.searchResults;
      store.dispatch(resetStateField('searchResults'));
    }
    if (state.notifications.length !== this.notifications.length) {
      // Get a list of elements that different between this.notifications and state.notifications
      if (!this.addedNotifications) { this.addedNotifications = []; }
      this.addedNotifications = this.addedNotifications.concat(state.notifications.filter(notification => !this.notifications.includes(notification)));
      this.notifications = state.notifications;
      
      // Clear any existing timeout to prevent race conditions
      if (this.notificationTimeout) {
        clearTimeout(this.notificationTimeout);
      }

      this.notificationTimeout = setTimeout((() => {
        // Remove the added notifications
        // store.dispatch(resetStateField('notifications'));
        this.notifications = this.notifications.filter(notification => !this.addedNotifications.includes(notification));
        if (this.notifications.length === 0) {
          store.dispatch(resetStateField('notifications'));
        }
        this.notificationTimeout = null; // Clear the timeout reference
      }).bind(this), 3000);
    }
  }

  static get routes() {
    return [
      {
        name: "main",
        pattern: "",
        data: { title: "Home", type: "main" },
      },
      {
        name: "main",
        pattern: "post",
        data: { type: "main" },
      },
      {
        name: "main",
        pattern: "post/:id",
        data: { type: "main" },
      },
      {
        name: "main",
        pattern: "interest/:id",
        data: { type: "main", id: "interest" },
      },
      {
        name: "main",
        pattern: "interest/:id/trending",
        data: { type: "trending", id: "interest" },
      },
      {
        name: "main",
        pattern: "interest/:id/fresh",
        data: { type: "fresh", id: "interest" },
      },
      {
        name: "main",
        pattern: "interest/:id/top",
        data: { type: "top", id: "interest" },
      },
      {
        name: "main",
        pattern: "trending",
        data: { type: "trending" },
      },
      {
        name: "main",
        pattern: "fresh",
        data: { type: "fresh" },
      },
      {
        name: "main",
        pattern: "top",
        data: { type: "top" },
      },
      {
        name: "main",
        pattern: "tag/:id",
        data: { title: "tag", id: "tag" },
      },
      {
        name: "main",
        pattern: "tag/:id/trending",
        data: { type: "trending", id: "tag" },
      },
      {
        name: "main",
        pattern: "tag/:id/fresh",
        data: { type: "fresh", id: "tag" },
      },
      {
        name: "main",
        pattern: "tag/:id/top",
        data: { type: "top", id: "tag" },
      },
      {
        name: "post",
        pattern: "submit",
        data: { title: "Post", mustBeLoggedIn: true },
      },
      {
        name: "login",
        pattern: "login",
        data: { title: "Login" },
      },
      {
        name: "settings",
        pattern: "settings",
        data: { title: "Settings", mustBeLoggedIn: true },
      },
      {
        name: "settings",
        pattern: "settings/account",
        data: { title: "Account", mustBeLoggedIn: true },
      },
      {
        name: "settings",
        pattern: "settings/password",
        data: { title: "Password", mustBeLoggedIn: true },
      },
      {
        name: "settings",
        pattern: "settings/profile",
        data: { title: "Profile", mustBeLoggedIn: true },
      },
      {
        name: "settings",
        pattern: "settings/privacy&safety",
        data: { title: "Privacy & Safety", mustBeLoggedIn: true },
      },
      {
        name: "settings",
        pattern: "settings/content",
        data: { title: "Content You See", mustBeLoggedIn: true },
      },
      {
        name: "profile",
        pattern: "profile",
        data: { title: "User Profile", type: "posts", mustBeLoggedIn: true },
      },
      {
        name: "profile",
        pattern: "profile/posts",
        data: { title: "User Posts", type: "posts", mustBeLoggedIn: true },
      },
      {
        name: "profile",
        pattern: "profile/upvotes",
        data: { title: "User Upvotes", type: "upvotes", mustBeLoggedIn: true },
      },
      {
        name: "profile",
        pattern: "profile/saved",
        data: { title: "User Saved", type: "saved", mustBeLoggedIn: true },
      },
      {
        name: "profile",
        pattern: "profile/comments",
        data: { title: "User Comments", type: "comments", mustBeLoggedIn: true },
      },
      {
        name: "profile",
        pattern: "user/(.*)",
        data: { title: "Viewing Profile", type: "posts" },
      },
      {
        name: "profile",
        pattern: "user/(.*)/posts",
        data: { title: "User Posts", type: "posts" },
      },
      {
        name: "profile",
        pattern: "user/:id(.*)/upvotes",
        data: { title: "User Upvotes", type: "upvotes" },
      },
      {
        name: "profile",
        pattern: "user/:id(.*)/saved",
        data: { title: "User Saved", type: "saved" },
      },
      {
        name: "profile",
        pattern: "user/:id(.*)/comments",
        data: { title: "User Comments", type: "comments" },
      },
      {
        name: "tos-policies",
        pattern: "tos-policies",
        data: { title: "TOS and Policies" },
      },
      {
        name: "data-deletion",
        pattern: "data-deletion",
        data: { title: "Data Deletion" },
      },
      {
        name: "not-found",
        pattern: "*",
      },
    ];
  }

  updated(changedProperties) {
    if (this.mustBeLoggedIn && !this.user) {
      this.mustBeLoggedInDialog = true;
      this.mustBeLoggedInDialogOptional = false;
    }
    else {
      this.mustBeLoggedInDialog = false;
      this.mustBeLoggedInDialogOptional = false;
    }
  }

  router(route, params, query, data) {
    if (!(this.route === route)) {
      store.dispatch(setRoute(route));
    }
    this.route = route;
    this.params = params;
    this.query = query;
    this.mainType = (data && data.type) ? data.type : "main";
    if (data && data.id === "interest") {
      this.mainId = params.id;
      this.selected = "interest";
    }
    else if (data && data.id === "tag") {
      this.mainId = params.id;
      this.selected = "tag";
    }
    else if (route === "main" && params && params.id) {
      this.postOpen = params.id;
    }
    else if (data && data.type) {
      this.selected = data.type;
      this.mainId = "";
    }
    else {
      this.mainId = "";
    }
    if (data && data.title === "Home") {
      document.title = 'Roflcopter | Good Mood Website';
    }
    else if (data.id === "interest") {
      const category = this.categories.filter(category => category.id === params.id);
      document.title = (data.type && data.type !== "main") ? data.type.charAt(0).toUpperCase() + data.type.slice(1) + ' | ' + category[0].title + ' | Roflcopter' : category[0].title + ' | Roflcopter';
    }
    else if (data.id === "tag") {
      document.title = (data.type && data.type !== "main") ? data.type.charAt(0).toUpperCase() + data.type.slice(1) + ' | ' + params.id + ' | Roflcopter' : params.id + ' | Roflcopter';
    }
    else if (!params.id) {
      document.title = data.type ? data.type.charAt(0).toUpperCase() + data.type.slice(1) + ' | Roflcopter' : data.title + ' | Roflcopter';
    }
    if (route === "profile") {
      this.selectedProfileTab = data.type;
    }
    if (data && data.mustBeLoggedIn) {
      this.mustBeLoggedIn = true;
      this.mustBeLoggedInDialogOptional = false;
    }
    else {
      this.mustBeLoggedIn = false;
      this.mustBeLoggedInDialogOptional = false;
    }
  }

  getTheme() {
    return this.theme;
  }

  toggleNotify(e) {
    e.preventDefault();
    this.notifyOpen = !this.notifyOpen;
    this.profileDropdownOpen = false;
    if (this.mobileMode) {
      this.toggleMenu = false;
    }
  }


  toggleDropdown() {
    this.profileDropdownOpen = !this.profileDropdownOpen;
    if (this.mobileMode) {
      this.toggleMenu = false;
    }
    this.notifyOpen = false;
  }

  dropdownSelect(e) {
    const type = e.detail.type;
    switch (type) {
      case "log-out":
        authManager.logOff();
        store.dispatch(resetStateField('accessToken'));
        store.dispatch(resetStateField('user'));
        localStorage.removeItem("user");
        this.requestUpdate();
        break;
      case "customize-tags":
        store.dispatch(setFollowingDialog(true));
        break;
    }
    this.profileDropdownOpen = false;
  }

  updateUser(e) {
    e.preventDefault();
    var username = this.shadowRoot.getElementById("username").value;
    if (username === this.user.username) {
      username = "";
    }
    var display_name = this.shadowRoot.getElementById("display-name").value;
    if (display_name === this.user.display_name) {
      display_name = "";
    }
    var birthday = this.shadowRoot.getElementById("birthday").value;
    if (birthday === this.user.birthday) {
      birthday = "";
    }
    const profile_pic = this.shadowRoot.getElementById("profile-picture-url").value;
    const newSettings = { username, display_name, birthday, profile_pic };
    if (username === "") {
      delete newSettings.username;
    }
    if (display_name === "") {
      delete newSettings.display_name;
    }
    if (birthday === "") {
      delete newSettings.birthday;
    }
    if (profile_pic === "") {
      delete newSettings.profile_pic;
    }
    if (Object.keys(newSettings).length > 0) {
      store.dispatch(updateSettings(newSettings));
      this.updatingUser = true;
    }
    else {
      this.updatingUser = false;
      this.newUserCreated = false;
    }
  }

  static styles = [
    super.styles,
    css`
    #sidebar {
      position: fixed;
      top: 3rem;
      bottom: 0;
      left: 0;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -ms-flex-direction: column;
      flex-direction: column;
      width: 18rem;
      background-color: #FAFAFB;
      border-right: 1px solid #d8dee6;
      overflow-y: auto;
      z-index: 100;
      --drawer-delta: 0;
      transform: translateX(calc(-1* var(--drawer-delta)));
      transition: transform 0.3s ease-in-out, top 0.3s ease-in-out;
    }
    .dark#sidebar {
      background-color: #2b2826;
      color: #a9a9a9;
      border-right: 1px solid #1a1b1e;
    }
    #site-main-content {
      margin-top: 2.25rem;
    }
    #site-main-content.expanded {
      margin-left: 18rem;
    }
    .dark>.slds-builder-header {
      background: #1a1b1e;
    }
    main.dark#site-main-content {
      background-color: #2b2826;
      color: white;
    }
    main {
      padding-top: 1rem;
    }
    .dark a:active {
      color: #b0adab;
    }
    .dark .slds-builder-header__item-action:hover, .dark .slds-builder-header__item-action:focus {
      background-color: #3e3e3c;
    }
    .dark .slds-dropdown__header {
      color: white;
    }
    @media only screen and (max-width: 600px) {
      #search .slds-media__body {
        display: none;
      }
      #search .slds-media__figure {
        margin-right: 0;
      }
      #alert .slds-media__body {
        display: none;
      }
      #alert .slds-media__figure {
        margin-right: 0;
      }
    }
    .dark slds-spinner {
      --background-color: #181818;
    }
    [hidden] {
      display: none;
    }
    .app-content {
      display: none;
    }
    .app-content[loaded] {
      display: block;
    }
    .dark sidebar-component {
      --background-color: #2b2826;
      --font-color: white;
      --active-background: #505050;
      --active-border: #706e6b;
      --slds-c-icon-color-foreground-default: white;
    } 
    sidebar-component {
      --background-color: #FAFAFB;
      --font-color: #181818;
      --active-background: white;
      --active-border: #e5e5e5;
    }
    .dark login-view, .dark notify-view, .dark profile-view, 
    .dark main-view, .dark slds-dialog, .dark slds-dropdown, 
    .dark settings-view, .dark view-post, .dark feed-view, 
    .dark post-view, .dark slds-search, .dark slds-lookup,
    .dark tos-policies-view, .dark data-deletion-view {
      --background-color: #2b2826;
      --replies-background: #403e3c;
      --table-hover: #000000;
      --text-color: white;
      --border-color: #c9c9c9;
      --input-text-color: #181818;
    }
    .dark .slds-app-launcher__tile-body {
      background-color: #505050;
    }
    .dark single-post, .dark main-view, .dark profile-view {
      --slds-c-badge-color-background: var(--slds-c-badge-inverse-color-background, var(--sds-c-badge-inverse-color-background, #747474));
      --slds-c-badge-text-color: var(--slds-c-badge-inverse-text-color, var(--sds-c-badge-inverse-text-color, #fff));
    }
    .dark .slds-input {
      --slds-c-input-color-background: #2b2826;
    }
    .dark .slds-form-element__label {
      color: white;
    }
    .dark .slds-button--neutral, .dark .slds-button_neutral {
      --slds-c-button-color-background: #2b2826;
    }
    .slds-avatar_x-large {
      height: 4rem;
      width: 4rem;
    }
    .notifications {
      z-index: 50;
      width: 100%;
      margin-left: -8rem;
    }
    @keyframes fadeOut {
      0% {
        opacity: 1;
      }
      100% {
        opacity: 0;
      }
    }
    .fade-out {
      animation: fadeOut 1s ease-out 1s forwards;
    }
    .shadow-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.8);
      z-index: 80;
    }
    .slds-builder-header_container {
      transition: transform 0.3s ease-in-out;
    }
    .slds-builder-header_container.hidden {
      transform: translateY(-100%);
    }
    #sidebar.hidden {
      top: 0;
    }
  `
  ];

  selectItem(e) {
    e.preventDefault();
    if (this.mobileMode) {
      this.toggleMenu = false;
    }
    var href = e.target.closest("a").href;
    var selected = href.split("/").pop();
    history.pushState({}, null, "/" + selected);
    window.dispatchEvent(new CustomEvent('route'));
  }

  selectSearchItem(e) {
    e.preventDefault();
    this.postOpen = e.detail.id;
  }

  getFirstCharsOfFirstTwoWords(inputString) {
    if (!inputString) {
      return "";
    }
    // Split the input string into an array of words
    const words = inputString.split(" ");

    // Check if there are at least two words
    if (words.length < 2) {
        return "";
    }

    // Extract the first two characters of the first two words, capitalize them, and return
    const firstWord = words[0].substring(0, 1).toUpperCase();
    const secondWord = words[1].substring(0, 1).toUpperCase();

    return firstWord+secondWord;
  }

  randomizeProfilePicture() {
    var profile_pic = `${window.cdnUrl}avatars/${Math.floor(Math.random() * 10979)}.webp`;
    this.shadowRoot.getElementById("profile-picture-url").value = profile_pic;
    const user = { ...this.user, profile_pic: profile_pic };
    store.dispatch(setUser(user));
    this.requestUpdate();
  }

  handleProfilePictureChange(e) {
    const file = e.target.files[0];
    const formData = new FormData();
    formData.append("file", file);
    store.dispatch(uploadProfilePicture(formData));
  }

  search(e) {
    e.preventDefault();
    if (this.mobileMode) {
      this.toggleMenu = false;
    }
    store.dispatch(search(e.detail, this.user?.adultContent));
  }

  redirectToLogin() {
    history.pushState({}, null, "/login");
    window.dispatchEvent(new CustomEvent('route'));
    this.mustBeLoggedInDialog = false;
    this.mustBeLoggedInDialogOptional = false;
  }

  closeMenu() {
    if (this.mobileMode) {
      this.toggleMenu = false;
      this.shadowRoot.getElementById('sidebar').style.setProperty('--drawer-delta', '18rem');
    }
  }

  startDrag(event) {
    this.isDragging = true;
    const clientX = event.type.includes('touch') ? event.touches[0].clientX : event.clientX;
    this.previousX = clientX;
    this.startX = clientX;
  }
  
  drag(event) {
    if (!this.isDragging) return;
    
    const clientX = event.type.includes('touch') ? event.touches[0].clientX : event.clientX;
    const deltaX = clientX - this.startX;
    
    const sidebar = this.shadowRoot.getElementById('sidebar');
    
    // If menu is expanded, negative deltaX closes menu
    // If menu is collapsed, positive deltaX opens menu
    let drawerPosition;
    if (this.toggleMenu) {
      // When expanded, right swipe increases position (closes)
      drawerPosition = Math.max(0, Math.min(18, -deltaX / 16));
    } else {
      // When collapsed, right swipe decreases position (opens)
      drawerPosition = Math.max(0, Math.min(18, 18 - deltaX / 16));
    }
    
    sidebar.style.setProperty('--drawer-delta', `${drawerPosition}rem`);
    
    // When drawer is fully closed, update toggleMenu state
    if (drawerPosition === 18) {
      this.toggleMenu = false;
    }
    
    // Overlay opacity based on drawer position
    const overlay = this.shadowRoot.querySelector('.shadow-overlay');
    if (overlay) {
      overlay.style.opacity = (18 - drawerPosition) / 18 * 0.8;
      overlay.style.display = 'block';
    }
  }
  
  stopDrag(event) {
    if (!this.isDragging) return;
    
    const clientX = event.type.includes('touch') ? event.changedTouches[0].clientX : event.clientX;
    const deltaX = clientX - this.startX;
    
    const sidebar = this.shadowRoot.getElementById('sidebar');
    const overlay = this.shadowRoot.querySelector('.shadow-overlay');
    
    // Threshold for snap is 25% of 18rem (4.5rem = 72px)
    const threshold = 72;
    
    if (this.toggleMenu) {
      // When expanded, snap closed if dragged right more than threshold
      if (-deltaX > threshold) {
        sidebar.style.setProperty('--drawer-delta', '18rem');
        if (overlay) overlay.style.opacity = '0';
        this.toggleMenu = false;
      } else {
        sidebar.style.setProperty('--drawer-delta', '0rem');
        if (overlay) overlay.style.opacity = '0.8';
        this.toggleMenu = true;
      }
    } else {
      // When collapsed, snap open if dragged right more than threshold
      if (deltaX > threshold) {
        sidebar.style.setProperty('--drawer-delta', '0rem');
        if (overlay) overlay.style.opacity = '0.8';
        this.toggleMenu = true;
      } else {
        sidebar.style.setProperty('--drawer-delta', '18rem');
        if (overlay) overlay.style.opacity = '0';
        this.toggleMenu = false;
      }
    }
    
    this.isDragging = false;
  }

  toggleMenuAction() {
    this.toggleMenu = !this.toggleMenu;
    this.shadowRoot.getElementById('sidebar').style.setProperty('--drawer-delta', this.toggleMenu ? '0rem' : '18rem');
  }

  render() {
    return html`
      <slds-spinner .loading="${this.isLoading}"></slds-spinner>
      <div class="app-content ${this.mobileMode && this.toggleMenu ? 'expanded' : ''}" ?loaded="${!this.isLoading}" @pointerdown="${this.startDrag}" @pointermove="${this.drag}" @pointerup="${this.stopDrag}" @pointercancel="${this.stopDrag}" >
        ${this.mobileMode && this.toggleMenu ? html`<div class="shadow-overlay" @click="${this.closeMenu}"></div>` : ''} 
        <section id="sidebar" class="${this.getTheme()} ${this.headerHidden ? 'hidden' : ''}"><sidebar-component @close="${this.closeMenu}" .selected="${this.selected}" .category="${this.mainId}" class="${this.getTheme()}" .categories="${this.categories}"></sidebar-component></section>
        <!-- <vertical-navigation></vertical-navigation> -->
        <div class="slds-builder-header_container ${this.headerHidden ? 'hidden' : ''} ${this.getTheme()}">
          <header class="slds-builder-header">
            <div class="slds-builder-header__item">
              <a href="javascript:void(0)" @click="${this.toggleMenuAction}" class="slds-builder-header__item-action" title="Expand Menu">
                <span class="slds-icon_container slds-icon-utility-back slds-current-color">
                  <svg class="slds-icon slds-icon_x-small" aria-hidden="true">
                    <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#rows"></use>
                  </svg>
                  <span class="slds-assistive-text">Expand Menu</span>
                </span>
              </a>
            </div>
            <div class="slds-builder-header__item">
              <a href="/" @click="${this.selectItem}" class="slds-builder-header__item-action slds-media slds-media_center slds-text-link_reset">
                <div class="slds-media__body">
                  <svg viewBox="0 0 82.20960000000001 18.36" width="82.21px" height="18.36px" xmlns="http://www.w3.org/2000/svg">
                    <path fill="white" d="M 8.6 15.12 L 8.6 15.01 C 7.99 14.75 7.91 14.34 7.91 12.98 L 7.91 9.74 C 7.91 9.12 7.84 8.4 7.15 7.8 C 6.78 7.47 6.35 7.34 6.22 7.3 L 6.22 7.24 C 6.76 7.17 7.15 6.91 7.41 6.65 C 7.97 6.07 8.06 5.36 8.06 4.82 L 8.06 3.09 C 8.06 2.4 7.86 1.47 7.41 0.93 C 7 0.43 6.16 0 4.82 0 L 0.76 0 L 0.76 15.12 L 3.22 15.12 L 3.22 8.51 L 4.19 8.51 C 4.45 8.51 4.82 8.53 5.08 8.75 C 5.42 9.05 5.44 9.53 5.44 9.94 L 5.44 13.33 C 5.44 13.87 5.44 14.47 5.81 15.12 L 8.6 15.12 Z M 3.22 6.24 L 3.22 2.12 L 4.6 2.12 C 4.86 2.12 5.18 2.14 5.4 2.46 C 5.49 2.59 5.59 2.83 5.59 3.48 L 5.59 5.03 C 5.59 5.31 5.57 5.77 5.23 6.03 C 4.97 6.22 4.62 6.24 4.32 6.24 L 3.22 6.24 Z M 16.91 3.33 C 16.91 2.46 16.87 1.53 15.9 0.67 C 15.03 -0.09 13.95 -0.22 13.15 -0.22 C 12.36 -0.22 11.28 -0.09 10.41 0.67 C 9.44 1.53 9.4 2.46 9.4 3.33 L 9.4 11.79 C 9.4 12.66 9.44 13.59 10.41 14.45 C 11.28 15.21 12.36 15.34 13.15 15.34 C 13.95 15.34 15.03 15.21 15.9 14.45 C 16.87 13.59 16.91 12.66 16.91 11.79 L 16.91 3.33 Z M 11.86 3.41 C 11.86 3.07 11.88 2.66 12.1 2.35 C 12.4 1.94 12.87 1.9 13.15 1.9 C 13.44 1.9 13.91 1.94 14.21 2.35 C 14.43 2.66 14.45 3.07 14.45 3.41 L 14.45 11.71 C 14.45 12.05 14.43 12.46 14.21 12.77 C 13.91 13.18 13.44 13.22 13.15 13.22 C 12.87 13.22 12.4 13.18 12.1 12.77 C 11.88 12.46 11.86 12.05 11.86 11.71 L 11.86 3.41 Z M 31.88 15.12 L 31.88 13 L 27.82 13 L 27.82 0 L 25.36 0 L 25.36 15.12 L 31.88 15.12 Z M 20.21 15.12 L 20.21 8.08 L 23.15 8.08 L 23.15 5.96 L 20.21 5.96 L 20.21 2.12 L 24.03 2.12 L 24.03 0 L 17.75 0 L 17.75 15.12 L 20.21 15.12 Z M 40.22 9.42 L 37.76 9.42 L 37.76 11.9 C 37.76 12.2 37.76 12.53 37.52 12.83 C 37.26 13.15 36.87 13.22 36.57 13.22 C 36.29 13.22 35.88 13.18 35.55 12.85 C 35.23 12.51 35.25 12.16 35.25 11.79 L 35.25 3.3 C 35.25 2.94 35.27 2.51 35.62 2.2 C 35.79 2.05 36.07 1.9 36.53 1.9 C 36.87 1.9 37.17 1.99 37.41 2.25 C 37.71 2.57 37.71 2.89 37.71 3.24 L 37.71 5.1 L 40.18 5.1 L 40.18 3.43 C 40.18 2.66 40.05 1.53 39.07 0.67 C 38.49 0.15 37.63 -0.22 36.5 -0.22 C 35.55 -0.22 34.62 -0.02 33.8 0.73 C 32.98 1.49 32.79 2.27 32.79 3.22 L 32.79 11.51 C 32.79 12.48 32.88 13.5 33.83 14.36 C 34.56 15.03 35.62 15.34 36.55 15.34 C 37.69 15.34 38.69 14.95 39.31 14.36 C 40.09 13.63 40.22 12.81 40.22 11.97 L 40.22 9.42 Z M 48.97 3.33 C 48.97 2.46 48.92 1.53 47.95 0.67 C 47.09 -0.09 46.01 -0.22 45.21 -0.22 C 44.41 -0.22 43.33 -0.09 42.47 0.67 C 41.49 1.53 41.45 2.46 41.45 3.33 L 41.45 11.79 C 41.45 12.66 41.49 13.59 42.47 14.45 C 43.33 15.21 44.41 15.34 45.21 15.34 C 46.01 15.34 47.09 15.21 47.95 14.45 C 48.92 13.59 48.97 12.66 48.97 11.79 L 48.97 3.33 Z M 43.91 3.41 C 43.91 3.07 43.93 2.66 44.15 2.35 C 44.45 1.94 44.93 1.9 45.21 1.9 C 45.49 1.9 45.96 1.94 46.27 2.35 C 46.48 2.66 46.5 3.07 46.5 3.41 L 46.5 11.71 C 46.5 12.05 46.48 12.46 46.27 12.77 C 45.96 13.18 45.49 13.22 45.21 13.22 C 44.93 13.22 44.45 13.18 44.15 12.77 C 43.93 12.46 43.91 12.05 43.91 11.71 L 43.91 3.41 Z M 52.88 15.12 L 52.88 8.77 C 53.46 8.86 54.17 8.9 54.71 8.88 C 55.79 8.83 56.51 8.49 56.89 8.08 C 57.61 7.34 57.63 6.29 57.63 5.57 L 57.63 3.3 C 57.63 2.57 57.61 1.64 56.89 0.91 C 56.4 0.39 55.47 0 54.54 0 L 50.41 0 L 50.41 15.12 L 52.88 15.12 Z M 52.88 6.65 L 52.88 2.12 L 54 2.12 C 54.24 2.12 54.69 2.14 54.95 2.48 C 55.17 2.76 55.17 3.13 55.17 3.48 L 55.17 5.1 C 55.17 5.88 55.1 6.11 55.06 6.2 C 54.86 6.65 54.54 6.65 54.19 6.65 L 52.88 6.65 Z M 63.18 15.12 L 63.18 2.12 L 65.79 2.12 L 65.79 0 L 58.06 0 L 58.06 2.12 L 60.72 2.12 L 60.72 15.12 L 63.18 15.12 Z M 66.66 15.12 L 73.29 15.12 L 73.29 13 L 69.12 13 L 69.12 7.86 L 72.1 7.86 L 72.1 5.75 L 69.12 5.75 L 69.12 2.12 L 72.96 2.12 L 72.96 0 L 66.66 0 L 66.66 15.12 Z M 82.1 15.12 L 82.1 15.01 C 81.5 14.75 81.41 14.34 81.41 12.98 L 81.41 9.74 C 81.41 9.12 81.35 8.4 80.65 7.8 C 80.29 7.47 79.86 7.34 79.73 7.3 L 79.73 7.24 C 80.27 7.17 80.65 6.91 80.91 6.65 C 81.48 6.07 81.56 5.36 81.56 4.82 L 81.56 3.09 C 81.56 2.4 81.37 1.47 80.91 0.93 C 80.5 0.43 79.66 0 78.32 0 L 74.26 0 L 74.26 15.12 L 76.72 15.12 L 76.72 8.51 L 77.7 8.51 C 77.95 8.51 78.32 8.53 78.58 8.75 C 78.93 9.05 78.95 9.53 78.95 9.94 L 78.95 13.33 C 78.95 13.87 78.95 14.47 79.32 15.12 L 82.1 15.12 Z M 76.72 6.24 L 76.72 2.12 L 78.11 2.12 C 78.36 2.12 78.69 2.14 78.9 2.46 C 78.99 2.59 79.1 2.83 79.1 3.48 L 79.1 5.03 C 79.1 5.31 79.08 5.77 78.73 6.03 C 78.47 6.22 78.13 6.24 77.82 6.24 L 76.72 6.24 Z" style="transform-origin: 41.43px 7.56px;"/>
                  </svg>
                </div>
              </a>
            </div>
            <div class="slds-builder-header__item slds-builder-header__utilities">
              <div class="slds-builder-header__nav-item" id="search">
                <slds-search @search="${this.search}" @select="${this.selectSearchItem}" .items="${this.searchResults}"></slds-search>
              </div>
              ${this.user ? html`<div class="slds-builder-header__utilities-item" id="alert">
                <a href="javascript:void(0)" @click="${this.toggleNotify}" class="slds-builder-header__item-action slds-media slds-media_center">
                  <span class="slds-media__figure">

                    <span class="slds-icon_container slds-icon-utility-settings slds-current-color">
                      <svg class="slds-icon slds-icon_x-small" aria-hidden="true">
                        <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#alert"></use>
                      </svg>
                    </span>
                  </span>
                  <span class="slds-media__body">
                    <span class="slds-truncate" title="Alerts">Alerts</span>
                  </span>
                </a>
              </div>` : ''}
              <notify-view style="position:absolute;top:calc(100% + 12px);right:14rem;" .open="${this.notifyOpen}" @close="${() => this.notifyOpen = false}"></notify-view>
              <nav class="slds-builder-header__item slds-builder-header__nav">
                <ul class="slds-builder-header__nav-list">
                    <li class="slds-builder-header__nav-item">
                      <slds-dropdown @select="${this.dropdownSelect}" @blur="${() => this.profileDropdownOpen = false}" .open="${this.profileDropdownOpen}" .options="${this.profileDropdown}">
                        <button @click="${this.toggleDropdown}" class="slds-button slds-builder-header__item-action slds-media slds-media_center slds-text-link_reset slds-p-top_x-small slds-p-bottom_x-small" aria-haspopup="true" aria-expanded="false" title="Click to open menu">
                          <span class="slds-media__body">
                            <span aria-hidden="true" class="slds-avatar slds-avatar_circle slds-chat-avatar">
                            ${this.user ?
                              this.user.profile_pic ? html`<img alt="${this.user.display_name}" src="${this.user.profile_pic}" title="${this.user.display_name}" />` : html`<abbr class="slds-avatar__initials slds-avatar__initials_inverse" title="${this.user.display_name}">${this.getFirstCharsOfFirstTwoWords(this.user.display_name)}</abbr>`
                              : html`<img alt="Guest" src="/assets/images/avatar3.png" title="Guest" />`
                            }
                            </span>
                            <span class="slds-icon_container slds-icon-utility-chevrondown slds-current-color">
                              <svg class="slds-icon slds-icon_x-small" aria-hidden="true">
                                <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#chevrondown"></use>
                              </svg>
                            </span>
                            <span class="slds-assistive-text">Show More</span>
                          </span>
                        </button>
                      </slds-dropdown>
                    </li>
                </ul>
              </nav>
              <div class="slds-builder-header__utilities-item">
                <div class="slds-media slds-media_center">
                  <div class="slds-media__body">
                    ${this.user === null ? 
                      html`<a href="/login" @click="${this.selectItem}">
                        <button class="slds-button slds-button_brand slds-m-left_medium slds-m-right_medium">
                          <svg class="slds-button__icon slds-button__icon_left" aria-hidden="true">
                            <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#user"></use>
                          </svg> Login
                        </button>
                      </a>` :
                      html`<a href="/submit" @click="${this.selectItem}">
                        <button class="slds-button slds-button_brand slds-m-left_medium slds-m-right_medium">
                          <svg class="slds-button__icon slds-button__icon_left" aria-hidden="true">
                            <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#download"></use>
                          </svg> Post
                        </button>
                      </a>`
                    }
                  </div>
                </div>
              </div>
            </div>
          </header>
        </div>
        <!-- If/else in class litelement -->
        <main role="main" class="${this.toggleMenu && !this.mobileMode ? 'expanded' : ''} ${this.getTheme()}" id="site-main-content" tabindex="-1">
          <div class="notifications slds-is-fixed">
            ${this.notifications.map(notification => html`
              <div class="slds-notify_container slds-is-relative fade-out">
                <div class="slds-notify slds-notify_toast slds-theme_${notification.type}" role="status">
                  <span class="slds-assistive-text">${notification.type}</span>
                  <span class="slds-icon_container slds-icon-utility-${notification.type} slds-m-right_small slds-no-flex slds-align-top" title="${notification.type}">
                    ${notification.type === 'success' ? html`<svg class="slds-icon slds-icon_small" aria-hidden="true"><use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#success"></use></svg>` : ''}
                    ${notification.type === 'warning' ? html`<svg class="slds-icon slds-icon_small" aria-hidden="true"><use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#warning"></use></svg>` : ''}
                    ${notification.type === 'error' ? html`<svg class="slds-icon slds-icon_small" aria-hidden="true"><use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#error"></use></svg>` : ''}
                  </span>
                  <div class="slds-notify__content">
                    <h2 class="slds-text-heading_small">${notification.content.heading} ${unsafeHTML(notification.content.message)}</h2>
                  </div>
                  <div class="slds-notify__close">
                    <button @click="${() => this.notifications = this.notifications.filter(n => n !== notification)}" class="slds-button slds-button_icon slds-button_icon-inverse" title="Close">
                      <svg class="slds-button__icon slds-button__icon_large" aria-hidden="true">
                        <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#close"></use>
                      </svg>
                      <span class="slds-assistive-text">Close</span>
                    </button>
                  </div>
                </div>
              </div>
            `)}
          </div>
          <router-outlet active-route=${this.route}>
            <main-view .selected="${this.selected}" .mainId="${this.mainId}" .categories="${this.categories}" .mainType="${this.mainType}" .postOpen="${this.postOpen}" .mobileMode="${this.mobileMode}" .route='${this.route}' route='main'></main-view>
            <post-view .categories="${this.categories.filter(category => (!category.adultContent || this.adultMode))}" .activeRoute="${this.route}" route='post'></post-view>
            <settings-view route='settings'></settings-view>
            <not-found route='not-found'></not-found>
            <tos-policies-view route='tos-policies'></tos-policies-view>
            <data-deletion-view route='data-deletion'></data-deletion-view>
            <login-view route='login'>
              <!-- Other content around the reCAPTCHA -->
              <slot></slot> <!-- This will include the light DOM content -->
              <!-- Other content around the reCAPTCHA -->
            </login-view>
            <profile-view .categories="${this.categories}" .activeRoute="${this.route}" .selectedTab="${this.selectedProfileTab}" route='profile'></profile-view>
            ${this.followingDialog ? html`<slds-dialog @close="${() => {this.followingDialog = false;}}">
              <span slot="header">Interests</span>
              <div slot="body">
                <ul class="slds-grid slds-grid_pull-padded slds-wrap">
                  ${this.categories.filter(category => !category.onlyPost && (!category.adultContent || this.adultMode)).map(category => html`
                    <li class="slds-p-horizontal_small slds-size_1-of-1" @click="${this.toggleFollowingCategory}" data-id="${category.id}">
                      <div class="slds-app-launcher__tile slds-text-link_reset slds-m-top_none">
                        <div class="slds-app-launcher__tile-figure">
                          <img src="${category.icon}" alt="${category.title}" class="slds-avatar slds-avatar_large" />
                        </div>
                        <div class="slds-app-launcher__tile-body">
                          <span class="slds-page-header__title slds-truncate slds-p-top_medium" title="${category.title}">${category.title}</span>
                        </div>
                        <div class="slds-app-launcher__tile-figure">
                          <div class="slds-form-element slds-p-top_small">
                            <div class="slds-form-element__control">
                              <div class="slds-checkbox">
                                <input type="checkbox" name="options" id="checkbox-unique-id-${category.id}" value="checkbox-unique-id-${category.id}" checked="" />
                                <label class="slds-checkbox__label" for="checkbox-unique-id-${category.id}">
                                  <span class="slds-checkbox_faux"></span>
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                  `)}
                </ul>
              </div>
              <div slot="footer">
                <button class="slds-button slds-button_neutral" aria-label="Cancel and close" @click="${() => {this.followingDialog = false;}}">Cancel</button>
                <button class="slds-button slds-button_brand">Next</button>
              </div>
            </slds-dialog>` : ''}
            ${this.newUserCreated ? html`<slds-dialog @close="${() => {this.newUserCreated = false;}}">
              <span slot="header">Welcome to the Community!</span>
              <div slot="body">
                <div class="slds-form">
                  <div class="slds-form-element slds-form-element_stacked">
                    <div class="slds-form-element__control">
                      <div class="slds-grid slds-wrap">
                        <div class="slds-col slds-size_2-of-12 slds-text-align_center">
                          <input type="hidden" id="profile-picture-url" class="slds-input" />
                          <span class="slds-avatar slds-avatar_circle slds-avatar_x-large">
                            <img alt="${this.user?.display_name}" src="${this.user?.profile_pic}" title="${this.user?.display_name}" />
                          </span>
                        </div>
                        <div class="slds-col slds-size_6-of-12 slds-m-top_small">
                          <input type="file" id="profile-picture" @change="${this.handleProfilePictureChange}" accept="image/*" class="slds-input" />
                        </div>
                        <div class="slds-col slds-size_4-of-12 slds-m-top_small">
                          <div class="slds-m-left_small">
                            <button class="slds-button slds-button_neutral" style="width:100%;" @click="${this.randomizeProfilePicture}">Randomize</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="slds-form-element slds-form-element_horizontal">
                    <label class="slds-form-element__label" for="username">Username</label>
                    <div class="slds-form-element__control">
                      <input type="text" id="username" placeholder="Enter your username" class="slds-input" .value="${this.user ? this.user.username : ''}" />
                    </div>
                  </div>
                  <div class="slds-form-element slds-form-element_horizontal">
                    <label class="slds-form-element__label" for="display-name">Display Name</label>
                    <div class="slds-form-element__control">
                      <input type="text" id="display-name" placeholder="Enter your display name" class="slds-input" .value="${this.user ? this.user.display_name : ''}" />
                    </div>
                  </div>
                  <div class="slds-form-element slds-form-element_horizontal">
                    <label class="slds-form-element__label" for="birthday">Birthday (Optional)</label>
                    <div class="slds-form-element__control slds-input-has-icon slds-input-has-icon_right">
                      <input type="date" id="birthday" class="slds-input" .value="${this.user ? this.user.birthday : ''}" />
                      <button class="slds-button slds-button_icon slds-input__icon slds-input__icon_right" title="Select a date">
                        <svg class="slds-button__icon" aria-hidden="true">
                          <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#event"></use>
                        </svg>
                        <span class="slds-assistive-text">Select a date</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div slot="footer">
                <button class="slds-button slds-button_neutral" aria-label="Cancel and close" @click="${() => {this.newUserCreated = false;}}">Cancel</button>
                <button class="slds-button slds-button_brand" @click="${this.updateUser}" ?disabled="${this.updatingUser}">Submit</button>
              </div>
            </slds-dialog>` : ''}
            ${this.openANewUser ? html`<slds-dialog .mandatory="${this.askToLogin.mandatory}" @close="${() => {this.openANewUser = false;}}">
              <span slot="header">Roflcopter Is the Home of the Funny</span>
              <div slot="body">
                <h3 class="slds-text-heading_small slds-m-bottom_medium slds-text-align_center">You need to authenticate to continue.</h3>
                <div class="login-options">
                  <div class="slds-form-element slds-form-element_horizontal">
                    <button @click="${this.loginFacebook}" class="slds-button slds-button_neutral" style="width:100%;">
                      Continue with Facebook
                    </button>
                  </div>
                  <div class="slds-form-element slds-form-element_horizontal">
                    <button @click="${this.loginGoogle}" class="slds-button slds-button_neutral" style="width:100%;">
                      Continue with Google
                    </button>
                  </div>
                  <div class="slds-form-element slds-form-element_horizontal">
                    <button @click="${this.loginApple}" class="slds-button slds-button_neutral" style="width:100%;">
                      Continue with Apple
                    </button>
                  </div>
                  <div class="slds-form-element slds-form-element_horizontal">
                    <button @click="${this.loginEmail}" class="slds-button slds-button_neutral" style="width:100%;">
                      Email / Password
                    </button>
                  </div>
                </div>
              </div>
            </slds-dialog>` : ''}
            ${this.mustBeLoggedInDialog ? html`<slds-dialog .mandatory="${!this.mustBeLoggedInDialogOptional}" @close="${() => {this.mustBeLoggedInDialog = false;}}">
              <span slot="header">You must be logged in to continue</span>
              <div slot="body">
                <h3 class="slds-text-heading_small slds-m-bottom_medium slds-text-align_center">Please authenticate yourself in order to complete this action.</h3>
              </div>
              <div slot="footer">
                ${this.mustBeLoggedInDialogOptional ? html`<button class="slds-button slds-button_neutral" aria-label="Cancel and close" @click="${() => {this.mustBeLoggedInDialog = false;}}">Cancel</button>` : ''}
                <button class="slds-button slds-button_brand" @click="${this.redirectToLogin}">Login</button>
              </div>
            </slds-dialog>` : ''}
          </router-outlet>
        </main>
      </div>
    `
  }
}